import { AxiosResponse } from 'axios';
import { FBaseService, ResponseEnvelope, ResponseEnvelopeCollection } from '@kasasa/fbase-components/lib'; 

class FbaseClientService extends FBaseService {
	getClients(params: FbaseFilter): Promise<AxiosResponse<ResponseEnvelopeCollection<FbaseClient>>> {
		return this.apiClient.get('/api/fbase-client/client', { params: params });
	}
	getClient(id: number): Promise<AxiosResponse<ResponseEnvelope<FbaseClient>>> {
		return this.apiClient.get(`/api/fbase-client/client/${id}`);
	}

	/* eslint-disable-next-line */
	postClient(client: FbaseClient): Promise<AxiosResponse<any>> {
		return this.apiClient.post('/api/fbase-client/client', client);
	}

	/* eslint-disable-next-line */
	updateClient(client: FbaseClient): Promise<AxiosResponse<any>> {
		return this.apiClient.put(`/api/fbase-client/client/${client.id}`, client);
	}

	/* eslint-disable-next-line */
	deleteClient(id: string): Promise<AxiosResponse<any>> {
		return this.apiClient.delete(`/api/fbase-client/client/${id}`);
	}

	/* eslint-disable-next-line */
	upsertClient(client: FbaseClient): Promise<AxiosResponse<any>> {
		if (client.id) {
			return this.updateClient(client);
		} else {
			return this.postClient(client);
		}
	}
}

class FbaseClient {
	id = '';
	title = '';
	name = '';
	enabled = 1;
	isKasasa = 0;
	customFolder = '';
	isDeleted = 0;
	fiId = '';
	isInternal = 0;
}

interface FbaseFilter {
	fiId?: number | null;
	includeDeleted?: number | null;
	name?: string | null;
	customFolder?: string | null;
}

export {
	FbaseClient,
	FbaseClientService,
	FbaseFilter
};